import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { FileSaverModule } from 'ngx-filesaver';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { LayoutComponent } from './layout/layout.component';
import { FullScreenComponent } from './layout/full-screen/full-screen.component';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { SharedMaterialModule } from './shared.material.module';

import { JwtInterceptor } from './jwt.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { NoCacheHeadersInterceptor } from './header.interceptor';

import { AlertDialogComponent } from './sotheby-common/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './sotheby-common/confirm-dialog/confirm-dialog.component';
import { IndicatorDialogComponent } from './sotheby-common/indicator-dialog/indicator-dialog.component';
import { SnackBarComponent } from './sotheby-common/snack-bar/snack-bar.component';
import { PopupDialogComponent } from './popup-dialog/popup-dialog.component';

import { AuthService } from 'src/services/auth.service';
import { AttachmentService } from 'src/services/attachment.service';
import { ConsignedMaterialCommonModelService } from 'src/services/consigned-material-common-model.service';
import { ConsignedMaterialInventoryService } from 'src/services/consigned-material-inventory.service';
import { ConsignedMaterialPaymentStatement } from 'src/services/consigned-material-payment-statement.service';
import { ConsignedMaterialProductPlanService } from 'src/services/consigned-material-product-plan.service';
import { ConsignedMaterialTransferService } from 'src/services/consigned-material-transfer.service';
import { CommonService } from 'src/services/common.service';
import { CommonCodeService } from 'src/services/common-code.service';
import { DefectManagementService } from 'src/services/defect-management.service';
import { NonconformanceService } from 'src/services/nonconformance.service';
// import { PackingSlipService } from 'src/services/packing-slip.service';
import { ProductService } from 'src/services/product.service';
import { ProductPlanService } from 'src/services/product-plan.service';
import { ProductMrpService } from 'src/services/product-mrp.service';
import { PurchaseService } from 'src/services/purchase.service';
import { ReceiptConfirmService } from 'src/services/receipt-confirm.service';
import { TaxInvoiceService } from 'src/services/tax-invoice.service';
import { TradeItemService } from 'src/services/trade-item.service';
import { UserService } from 'src/services/user.service';
import { UserAuthService } from 'src/services/user-auth.service';
import { VendorService } from 'src/services/vendor.service';
import { NoticeService } from 'src/services/notice.service';
import { GnbComponent } from './gnb/gnb.component';


import { SlickCarouselModule } from '../../node_modules/ngx-slick-carousel';
import { SharedPipeModule } from 'src/app/shared.pipe.module';

@NgModule({
  entryComponents: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    IndicatorDialogComponent,
    SnackBarComponent,
    PopupDialogComponent
  ],
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    FullScreenComponent,
    LayoutComponent,
    GnbComponent,
    PopupDialogComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }), SlickCarouselModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR }),
    AppRoutingModule,
    FileSaverModule,
    SharedMaterialModule,
    SharedPipeModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'ko' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NoCacheHeadersInterceptor, multi: true },
    AuthService,
    AttachmentService,
    CommonService,
    CommonCodeService,
    ConsignedMaterialCommonModelService,
    ConsignedMaterialInventoryService,
    ConsignedMaterialPaymentStatement,
    ConsignedMaterialProductPlanService,
    ConsignedMaterialTransferService,
    DefectManagementService,
    NonconformanceService,
    // PackingSlipService,
    ProductService,
    ProductPlanService,
    ProductMrpService,
    PurchaseService,
    ReceiptConfirmService,
    TaxInvoiceService,
    TradeItemService,
    UserService,
    UserAuthService,
    VendorService,
    NoticeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
